"use strict";

exports.__esModule = true;
exports.DeviceEditorPlantTwin = DeviceEditorPlantTwin;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../Form/FormGroupField");
var _Core = require("../../Core");
var _DeviceDataItemsContext = require("../DeviceDataItemsContext");
var _DeviceTagListContext = require("../DeviceTagListContext");
var _DeviceDataItemSelector = require("../DeviceDataItemSelector");
var _DeviceTagSelector = require("../DeviceTagSelector");
var _DeviceTypeSelector = require("../DeviceTypeSelector");
var _DeviceTypeListContext = require("../DeviceTypeListContext");
var _System = require("../../../System");
var _constants = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DEVICE_TYPE_MTCONNECT = "MTConnectDevice";
var DeviceEditorForm = _styledComponents["default"].form.withConfig({
  displayName: "DeviceEditorPlantTwin__DeviceEditorForm",
  componentId: "sc-1sstx6q-0"
})(["display:flex;flex:1;height:100%;flex-direction:column;h3{font-size:22px;margin:0 0 10px 0;}"]);
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "DeviceEditorPlantTwin__EditorBody",
  componentId: "sc-1sstx6q-1"
})(["padding:1rem;flex:1;display:flex;flex-direction:column;overflow:auto;"]);
var CheckBoxFormGroupField = (0, _styledComponents["default"])(_FormGroupField.FormGroupField).withConfig({
  displayName: "DeviceEditorPlantTwin__CheckBoxFormGroupField",
  componentId: "sc-1sstx6q-2"
})(["margin:0;.bp6-control{margin:0;}"]);
var EnabledCheckBoxWrapper = (0, _styledComponents["default"])(CheckBoxFormGroupField).withConfig({
  displayName: "DeviceEditorPlantTwin__EnabledCheckBoxWrapper",
  componentId: "sc-1sstx6q-3"
})(["padding:0 1rem 1rem 0rem;"]);

/**
 * Device editor form
 */
function DeviceEditorPlantTwin(props) {
  var deviceTags = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  var dataItems = _react["default"].useContext(_DeviceDataItemsContext.DeviceDataItemsContext);
  var deviceTypes = _react["default"].useContext(_DeviceTypeListContext.DeviceTypeListContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var device = props.device,
    _props$onCancelScreen = props.onCancelScreenName,
    onCancelScreenName = _props$onCancelScreen === void 0 ? "DeviceList" : _props$onCancelScreen;
  var initialValue = Object.assign({
    deviceType: [deviceTypes[0]]
  }, device, {
    realtimeDataItems: device.performanceParameters.realtimeDataItems,
    historicalDataItems: device.performanceParameters.historicalDataItems
  });
  var realtimeDataItems = dataItems.filter(function (i) {
    return i.category === _constants.CATEGORY_EVENT || i.category === _constants.CATEGORY_CONDITION || i.category === _constants.CATEGORY_SAMPLE;
  });
  // including representation prop here which is an old mtconnect convention no longer used but leaving in for legacy data support
  var historicalDataItems = dataItems.filter(function (i) {
    return i.category === _constants.CATEGORY_SAMPLE && i.representation !== "TIME_SERIES";
  });
  function validateName(value) {
    if (!value || !value.trim()) {
      return translate("DeviceEditorPlantTwin.validateName.required", "Name is required.");
    }
  }
  function validateForm() {
    return {};
  }
  function handleSubmit(values) {
    var onSubmit = props.onSubmit;
    var output = Object.assign({}, device);
    output.enabled = values.enabled;
    output.name = values.name.trim();
    output.allowProducing = values.allowProducing;
    output.tags = values.tags;
    output.currentCycleClassify = values.currentCycleClassify;
    output.deviceType = Array.isArray(values.deviceType) ? values.deviceType[0] : values.deviceType;
    output.performanceParameters = {
      realtimeDataItems: values.realtimeDataItems,
      historicalDataItems: values.historicalDataItems
    };
    onSubmit(output);
  }
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: Object.assign({}, initialValue),
    validate: validateForm,
    onSubmit: handleSubmit,
    mutators: Object.assign({}, _finalFormArrays["default"])
  }, function (_ref) {
    var handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      invalid = _ref.invalid,
      submitting = _ref.submitting,
      values = _ref.values;
    var isOfTypeMtConnectDevice = values.deviceType === DEVICE_TYPE_MTCONNECT;
    return /*#__PURE__*/_react["default"].createElement(DeviceEditorForm, {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.Prompt, {
      when: !pristine && !submitting,
      message: translate("DeviceEditorPlantTwin.form.prompt.message", "Are you sure you want to leave this page without saving your changes?")
    }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "DeviceEditorPlantTwin.saveButton",
      type: "submit",
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      text: translate("DeviceEditorPlantTwin.saveButton.text", "Save"),
      disabled: pristine || invalid
    }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      "data-testid": "DeviceEditorPlantTwin.cancelButton",
      minimal: true,
      end: true,
      icon: _icons.IconNames.CROSS,
      to: (0, _System.getScreenLocation)(onCancelScreenName),
      text: translate("DeviceEditorPlantTwin.cancelButton.text", "Cancel")
    }))), /*#__PURE__*/_react["default"].createElement(EditorBody, null, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "name",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.name",
        defaultMessage: "Name"
      }),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
      validate: validateName
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        "data-testid": "DeviceEditorPlantTwin.deviceName"
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "deviceType",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.deviceType",
        defaultMessage: "Device Type"
      }),
      requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null)
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceTypeSelector.DeviceTypeSelector, {
        items: deviceTypes,
        onSelect: input.onChange,
        onBlur: input.onBlur,
        selected: [input.value] || [],
        rightIcon: _icons.IconNames.CARET_DOWN,
        filterable: false,
        disabled: isOfTypeMtConnectDevice
      });
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "tags",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.tags",
        defaultMessage: "Tags"
      })
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
        shouldAddItemWhenNotInList: function shouldAddItemWhenNotInList(value) {
          return !deviceTags.find(function (tag) {
            return tag === value;
          });
        },
        multiple: true,
        items: deviceTags,
        onSelect: input.onChange,
        onBlur: input.onBlur,
        selected: input.value || [],
        rightIcon: _icons.IconNames.CARET_DOWN,
        minimal: true
      });
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "enabled",
      type: "checkbox"
    }, function (_ref5) {
      var input = _ref5.input;
      return /*#__PURE__*/_react["default"].createElement(_core.Switch, _extends({
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditorPlantTwin.enable.enabled.label",
          defaultMessage: "Enabled"
        })
      }, input));
    }), isOfTypeMtConnectDevice ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      name: "performanceParameters"
    }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "realtimeDataItems",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.dashboardDataItems",
        defaultMessage: "Dashboard Data Items"
      })
    }, function (_ref6) {
      var input = _ref6.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSelector.DeviceDataItemSelector, {
        placeholder: translate("DeviceDataItemSelector.placeholder.multiple.realtime", "Select Dashboard Data Items"),
        onSelect: input.onChange,
        onBlur: input.onBlur,
        items: realtimeDataItems,
        selected: input.value || [],
        rightIcon: _icons.IconNames.CARET_DOWN,
        minimal: true,
        multiple: true
      });
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "historicalDataItems",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.reportDataItems",
        defaultMessage: "Report Data Items"
      })
    }, function (_ref7) {
      var input = _ref7.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceDataItemSelector.DeviceDataItemSelector, {
        placeholder: translate("DeviceDataItemSelector.placeholder.multiple.historical", "Select Historical Data Items"),
        onSelect: input.onChange,
        onBlur: input.onBlur,
        items: historicalDataItems,
        selected: input.value || [],
        rightIcon: _icons.IconNames.CARET_DOWN,
        minimal: true,
        multiple: true
      });
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      name: "cycleClassifications",
      label: /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.cycleClassifications",
        defaultMessage: "Cycle Classifications"
      }))
    }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "currentCycleClassify",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DeviceEditorPlantTwin.currentCycleClassify",
        defaultMessage: "Default Current Cycle Classification"
      })
    }, function (_ref8) {
      var input = _ref8.input;
      return /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
        onChange: input.onChange,
        onBlur: input.onBlur,
        selectedValue: input.value
      }, /*#__PURE__*/_react["default"].createElement(_core.Radio, {
        label: translate("DeviceEditorPlantTwin.currentCycleClassify.radio.entire", "Entire - From Start of Cycle"),
        value: "ENTIRE"
      }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
        label: translate("DeviceEditorPlantTwin.currentCycleClassify.radio.fromNow", "From Now - From Time of Classification"),
        value: "FROMNOW"
      }));
    }), /*#__PURE__*/_react["default"].createElement(EnabledCheckBoxWrapper, {
      name: "allowProducing",
      type: "checkbox"
    }, function (_ref9) {
      var input = _ref9.input;
      return /*#__PURE__*/_react["default"].createElement(_core.Switch, _extends({
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "DeviceEditorPlantTwin.allowProducing",
          defaultMessage: "Allow Producing State Classification"
        })
      }, input));
    }))) : null));
  });
}